module.exports = __webpack_public_path__ + "media/images/Bathroom Cabinets-d34bb574.jpg";